import injectScript from '../document/inject-script';

import { Organization } from 'src/common/interfaces/organization.interface';
import { OrganizationUser } from 'src/common/interfaces/organization/user.interface';

export default async function loadParagon(paragon_token: string, journeyUser: OrganizationUser, organization: Organization) {
  if (window.paragon && window.paragon.getUser()) {
    return Promise.resolve(window.paragon);
  }

  try {
    await injectScript('https://cdn.useparagon.com/latest/sdk/index.js');
    if (window.paragon && process.env.PARAGON_ID && paragon_token) {
      return window.paragon
        .authenticate(process.env.PARAGON_ID, paragon_token)
        .then(() => {
          return window.paragon;
          // window.paragon.getUser();
        })
        .catch((error: any) => {
          console.log('Paragon authentication failed.', error);
          return Promise.reject(error);
        });
    } else {
      return window.paragon;
    }
  } catch (error) {
    return Promise.reject(error);
  }
}
